import styled from 'styled-components'

// O Header e uma superficie ESCURA sobre a pagina bege — segue a regra de
// card do DESIGN.md: fundo `surface`, texto `surfaceText`, divisor
// `surfaceAlt`. Nao usar `textPrimary`/`accent` aqui (sao tokens de pagina).

export const Container = styled.div`
  width: 100vw;
  height: 70px;
  background-color: ${({ theme }) => theme.colors.surface};
`;

export const Row = styled.div`
  height: 100%;  
`

export const Col = styled.div`
&:nth-child(1) {
  border-right: 1px solid ${({ theme }) => theme.colors.surfaceAlt}; 
}

padding: 0;
`

export const TitlePage = styled.p`
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.surfaceText};
  margin: 0;
`
